import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chart: {
		info: { apprentice: 0, investor: 0, sponsored: 0, quick: 0 },
		totalValue: { chart1: 0, chart2: 0 },
	},
	tableData: [{}],
	activateRequestModal: false,
	toggleFundFinanceReqModal: false,
	adminQuickAppRequests: null,
	investorSponsoredRequests: null,
};

export const ApprenticeshipSlice = createSlice({
	name: "apprenticeship",
	initialState,
	reducers: {
		updateChart: (state, action) => {
			state.chart = action.payload;
		},
		toggleActivateRequestModal: (state, action) => {
			state.activateRequestModal = action.payload;
		},
		onToggleFundFinanceReqModal: (state, action) => {
			state.toggleFundFinanceReqModal = action.payload;
		},
		saveAdminQuickRequests: (state, action) => {
			state.adminQuickAppRequests = action.payload;
		},
		saveInvestorSponsoredRequests: (state, action) => {
			state.investorSponsoredRequests = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateChart,
	toggleActivateRequestModal,
	onToggleFundFinanceReqModal,
	saveAdminQuickRequests,
	saveInvestorSponsoredRequests,
} = ApprenticeshipSlice.actions;

export default ApprenticeshipSlice.reducer;
